import { fromAPI } from "@cur8/rich-entity";
import { useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { useSession } from "render/context/MSALContext";

function queryFn(apiClient: APIClient, patientId: string) {
  return apiClient.visitSummary
    .querySummary({ patientId }, {})
    .result.then((value) => value.items.map(fromAPI.toVisitSummary));
}
function queryKey(patientId: string) {
  return ["appointment-summaries", patientId];
}

export function useAppointmentSummary() {
  const { patientId } = useSession();
  const api = useAPIClient();
  return useQuery({
    queryFn: () => queryFn(api, patientId),
    queryKey: queryKey(patientId),
  });
}
